import { manageUpdateAccessObj } from "../features/manageUpdateAccess/manageUpdateAccessTypes";
import { updateRequestBody } from "../features/updateMetaConfig/UpdateMetaConfigTypes";
import { getCurrentDateWithTime } from "../utils/utils";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "./networkService";

export async function getAllConfiguartions(){
    try {
        const response = await ChannelkartNetworkGet('/metadata');
        return response;
    } catch (error) {
        return error
    }
}

export async function sendConfigAnalyticsEvent(actionType:string,actionData: any,response: any, source: string,verifiedUser?: manageUpdateAccessObj){
    const analyticsBody={
        "response":response,
        "actionType": actionType,
        "actionData": actionData,
        "source": source,
        "extendedAttributes": {
            "activity": "",
            "mobTime": getCurrentDateWithTime(),
            "designation": "admin",
            "userDetail": verifiedUser
        }
    }
    await ChannelkartNetworkPost("/v1/analytics", analyticsBody);
    return response;
}